// extracted by mini-css-extract-plugin
export var boldText = "_6z-4";
export var checkboxContainer = "_6z-6";
export var closeIcon = "_6z-i";
export var container = "_6z-0";
export var drawer = "_6z-8";
export var drawerContent = "_6z-9";
export var extraSmallText = "_6z-5";
export var fulfillmentGroupTable = "_6z-e";
export var largeText = "_6z-3";
export var loadingSpinnerContainer = "_6z-j";
export var mediumText = "_6z-2";
export var narrow = "_6z-f";
export var notificationLink = "_6z-l";
export var packageCheckIconContainer = "_6z-7";
export var slideoutHeaderActions = "_6z-g";
export var slideoutHeaderActionsShifted = "_6z-h";
export var slideoutHeaderContainer = "_6z-a";
export var slideoutModal = "_6z-c";
export var stickyHeaderWrapper = "_6z-b";
export var table = "_6z-k";
export var tableContainer = "_6z-d";
export var tertiaryText = "_6z-1";